import React, { Component } from 'react';
import Text from './Text';
import { NavLink } from 'react-router-dom';

const publicPath = "/";
const HomeDescription = <div id="Descript">

Hello, welcome to my tutorial <strong> "Bitcoin price prediction and backtesting using LSTM with Keras and Tensorflow" </strong> <br/><br/>
This is my first tutorial and I wanted to combine two of my favorite topics: data science, in this case neural networks, and financial analysis. Most of the tutorials out there are about creating the neural network model, or about how to test a simple trading strategy, in this tutorial we will do both and also check the financial implications.
<br/><br/>
I’m going to include a lot of details and also test many strategies and transformations of the data so people can follow up even if they don’t know much about neural networks or designing a trading strategy and testing it.
<br/><br/>
The data that I’m going to use is CoinDesk’s daily bitcoin price and it can be found on their website.
It doesn’t matter when you download the data but if you want results as close as possible to mine you will have to remove the last observations, I’ll show you how to do that in Part 2.
<br/><br/>
To start let's go to <NavLink to={`${publicPath}enviroment`}>Part 1: Setting Up The Enviroment</NavLink>
</div>;

class Home extends Component {


  componentDidMount() {
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
            document.getElementById("myBtn").style.display = "block";
        } else {
            document.getElementById("myBtn").style.display = "none";
        }
    }

    function findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
          do {
              curtop += obj.offsetTop;
          } while (obj = obj.offsetParent);
      return [curtop];
      }
    }

    document.getElementById("myBtn").onclick = function() {
      const   scrollHeight = window.scrollY,
              scrollStep = Math.PI / ( 1000 / 15 ),
              cosParameter = scrollHeight / 2;
      var     scrollCount = 0,
              scrollMargin,
              scrollInterval = setInterval( function() {
                  if ( window.scrollY > 10 ) {
                      scrollCount = scrollCount + 1;  
                      scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
                      window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
                  } 
                  else clearInterval(scrollInterval); 
              }, 15 );
    }

    const scrollHeight = window.scrollY - findPos(document.getElementById("myNavbar"))[0],
    scrollStep = Math.PI / ( 1000 / 15 ),
    cosParameter = scrollHeight / 2;
    var scrollCount = 0,
    scrollMargin,
    scrollInterval = setInterval( function() {
        if ( window.scrollY - findPos(document.getElementById("myNavbar"))[0] > 10 ) {
            scrollCount = scrollCount + 1;  
            scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
            window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
        } 
        else clearInterval(scrollInterval); 
    }, 15 );
  }

  render() {
    return (
        <div id="home">
        <h1>Welcome to TheCryptosDB</h1>
          <Text Searchable="Time" description={HomeDescription}/>
        </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js